// src/useWebSocket.ts
import { useEffect, useRef, useState } from "react";
import store from '../../store/index'
import {message} from 'antd';
import {useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next'
import {getGameHis} from "../../api";

// 封装 WebSocket 的 Hook
export function useWebSocket(sec:string,game:string) {
const navigate = useNavigate()
  const ws = useRef<WebSocket | null>(null);      // WebSocket 实例
  const heartbeat = useRef<any>(null);            // 心跳定时器
  const reconnectTimer = useRef<any>(null);       // 自动重连定时器
const { t } = useTranslation()
  const [status, setStatus] = useState<"connecting" | "open" | "closed">("connecting");
  const [messages, setMessages] = useState<string>();
  const [qu, setQu] = useState<string>();

  // 创建连接的函数（可重复调用）
  const connect = () => {
    // console.log(store.getState().address)
    let _address = sec+"s"+store.getState().address 
   //const _url = "ws://localhost:9095/ws?user_id="+_address+"&&sec="+sec+"&&game="+game
    const _url = "wss://gameapi.feg.global/ws?user_id="+_address+"&&sec="+sec+"&&game="+game
    console.log(_url)
    message.loading("Connecting",1)
    
    ws.current = new WebSocket(_url); // 建立连接
    
    // 连接成功
    ws.current.onopen = () => {
      setStatus("open");
       message.success(t('game1.游戏服务器连接成功'))
      
      // 告诉服务器“我加入了聊天室”
      //ws.current?.send(JSON.stringify({ type: "join", sender: store.getState().address }));

      // 每 30 秒发一个“ping”保持连接
      // heartbeat.current = setInterval(() => {
      //   ws.current?.send(JSON.stringify({ type: "ping" }));
      // }, 10000);
      setTimeout(function() {
        _getHis()
    }, 1000);
      
    };

    // 收到服务器消息时触发
    ws.current.onmessage = (e) => {
     
      try {
        const data = JSON.parse(e.data);
        
        // 如果是聊天消息，加入到消息列表
        if (e.type === "message") {
          // console.log(data)
          setMessages(data);
          if(game=="2"){
            getQu2(data)
          }
        }
      } catch {}
    };

    // 连接断开（包括关闭和异常）
    ws.current.onclose = () => {
      setStatus("closed");
      message.error(t('game1.游戏服务器已断开'))
      clearInterval(heartbeat.current);
       
      
    };

    ws.current.onerror = () => {
      // message.error(t('game1.游戏服务器已断开')+"onerror")
      setStatus("closed");
      // 3 秒后尝试重新连接
      //reconnectTimer.current = setTimeout(connect, 3000);
    };
  };

  // 提供一个发送消息的函数
  // const sendMessage = (text: string) => {
  //   if (ws.current?.readyState === WebSocket.OPEN) {
  //     ws.current.send(JSON.stringify({ type: "chat", sender: store.getState().address, text }));
  //   }
  // };

  const _getHis = () =>{
      getGameHis().then(res=>{
                  if(res.data!==null){
                                   
                    if(sec == "30"){
                      getQu2(res.data.h30)
                    }else if (sec == "60"){
                      getQu2(res.data.h60)
                    }
                          
      
                  }
              })
  }

  const getQu2 =(_data:any) =>{
       
        if(_data==null){
            return
        }
        if(_data.history.length>0){
            let first =_data.history[0].petting_res2

        }
        let str = "<div class='w-4 mr-2'>"
        let index =0
        let useCol =0
            for(let i=0;i<=_data.history.length;i++){
                if(index==_data.history.length){
                    break
                }
                if(index==0){
                    if(_data.history[0].petting_res2 ==1){
                        str +="<div class='w-4 h-4  bg-red-500 mt-2 text-xs'></div>"
                    }else if(_data.history[0].petting_res2 ==2)(
                        str +="<div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>"
                    )
                    index++
                    useCol++
                }
                if(index>0){
                    if(_data.history[index].petting_res2 == _data.history[index-1].petting_res2){
                         if(useCol<5){
                            if(_data.history[index].petting_res2 ==1){
                                str +="<div class='w-4 h-4  bg-red-500 mt-2 text-xs'></div>"
                            }else if(_data.history[index].petting_res2 ==2)(
                                str +="<div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>"
                            )
                            index++
                            useCol++
                         }else if(useCol==5){
                            str +="</div>"
                            str +="<div class='w-4 mr-2'>"
                            if(_data.history[index].petting_res2 ==1){
                                str +="<div class='w-4 h-4  bg-red-500 mt-2 text-xs'></div>"
                            }else if(_data.history[index].petting_res2 ==2)(
                                str +="<div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>"
                            )
                            index++
                            useCol = 1
                         }
                         
                    }else{
                        for(let y=0;y<(5-useCol);y++){
                             str +="<div class='w-4 h-4  mt-2 text-xs'></div>"
                        }
                        str +="</div>"
                        str +="<div class='w-4 mr-2'>"
                        if(_data.history[index].petting_res2 ==1){
                            str +="<div class='w-4 h-4  bg-red-500 mt-2 text-xs'></div>"
                            }else if(_data.history[index].petting_res2 ==2)(
                                str +="<div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>"
                            )
                        index++
                        useCol = 1
                    }
                }
            }
            for(let y=0;y<(5-useCol);y++){
                    str +="<div class='w-4 h-4  mt-2 text-xs'></div>"
            }
            str +="</div>"
  
            setQu(str) 
            // <div class='w-4 mr-2'>
            //                     <div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //                     <div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //                     <div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //                     <div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //                     <div class='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //             </div>
        
        
    }


  // 页面加载时连接；页面关闭时断开
  useEffect(() => {
    connect();

    return () => {
      clearInterval(heartbeat.current);
      clearTimeout(reconnectTimer.current);
      ws.current?.close();
    };
  }, []);

  return { status, messages, qu };
}
